/**
 * This is basically ruby's (low...high).to_a range function
 *
 * Returns an array starting with min and ending with max-1
 * While this may seem counterintuitive, the goal is compatibility with ruby's range
 *
 */
export function range(min: number, max: number) {
  const result = [];
  for (let i = min; i < max; i++) {
    result.push(i);
  }
  return result;
}
